@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.content-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-button {
  height: 16px;
  width: 16px;
  .icon {
    height: 100%;
    width: 100%;
    fill: @settings-page--shipping-fulfilment-provider--icon-color;
  }
  &:hover {
    cursor: pointer;
  }
}
